var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBzTemperature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 48.62V7H29v41.62a13 13 0 1018 0zM38 67a9 9 0 01-5.73-15.94l.73-.6V11h10v6h-7v4h7v4h-7v4h7v21.46l.73.6A9 9 0 0138 67zm5-9a4.999 4.999 0 11-7-4.58V35h4v18.42A5 5 0 0143 58z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/BZ_Temperature.5e9bd350.svg";
export { SvgBzTemperature as ReactComponent };